import { render, staticRenderFns } from "./bi-form-success.vue?vue&type=template&id=7323536d&scoped=true&"
import script from "./bi-form-success.vue?vue&type=script&lang=ts&"
export * from "./bi-form-success.vue?vue&type=script&lang=ts&"
import style0 from "./bi-form-success.vue?vue&type=style&index=0&id=7323536d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7323536d",
  null
  
)

export default component.exports